import { lazy } from "react";

export const SpecialismPageContent = lazy(() => import("./SpecialismPageContent"));
